import type { PermissionData } from '../types'

export function computeCreateGeofencePermission(permissionData: PermissionData) {
  if (permissionData.rmOnly) return 'hidden'

  return 'enabled'
}
